import { Navigate, Outlet, lazyRouteComponent } from 'src/lib/routing';

import { RequireAuth } from 'containers/Auth/RequireAuth';

import type { RouteObject } from 'src/lib/routing';

const ExplorerConceptDetail = lazyRouteComponent(() => import('./ExplorerConceptDetail'), 'ExplorerConceptDetail');
const ExplorerEvidenceDetail = lazyRouteComponent(() => import('./ExplorerEvidenceDetail'), 'ExplorerEvidenceDetail');
const ExplorerTranscriptDetail = lazyRouteComponent(
  () => import('./ExplorerTranscriptDetail'),
  'ExplorerTranscriptDetail',
);
const ExplorerTranscriptsList = lazyRouteComponent(
  () => import('./ExplorerTranscriptsList'),
  'ExplorerTranscriptsList',
);

export const explorerRoutes: RouteObject[] = [
  {
    path: 'explorer',
    element: (
      <RequireAuth>
        <Outlet />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="transcripts" replace /> },
      { path: 'transcripts', element: <ExplorerTranscriptsList /> },
      { path: 'transcripts/:id', element: <ExplorerTranscriptDetail /> },
      { path: 'concepts/:id', element: <ExplorerConceptDetail /> },
      { path: 'evidence/:id', element: <ExplorerEvidenceDetail /> },
    ],
  },
];
